<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" class="tabs-container px-6">
		<div class="vx-row mb-4">
			<div class="vx-col w-full">
				<div class="flex flex-wrap items-center justify-end">
					<vs-button class="ml-auto" color="danger" @click.prevent="closePopupGenerateRepeat()">{{
						$t("Cancel")
					}}</vs-button>
					<vs-button class="ml-4" :disabled="isDisabled" @click.prevent="generateRepeat()">{{
						$t("Generate")
					}}</vs-button>
				</div>
			</div>
		</div>
		<div class="vx-row">
			<vs-sidebar
				v-if="isSidebarCalendar"
				click-not-close
				position-right
				default-index="1"
				color="primary"
				class="add-sidebar--repeat items-no-padding"
				style="z-index: 56000"
				v-model="isSidebarCalendar"
			>
				<div class="mt-2 flex items-center justify-between px-4">
					<h4>{{ $t("TimeWindow.Schedule") }} - {{ $t("RepeatFormat") }}</h4>
					<feather-icon
						:icon="'XIcon'"
						svgClasses="w-4 h-4 m-2"
						class="cursor-pointer bg-primary text-white rounded-full"
						@click="isSidebarCalendar = false"
					/>
				</div>
				<vs-divider class="mb-4" />
				<time-calendar
					ref="repeatCalendar"
					class="px-2"
					:viewData="true"
					:isMaximize="false"
					:cronExpression="cronExpression"
					:duration="
						getDaysInRange(
							{
								startDate: time_window.init_date,
								endDate: time_window.end_date,
							},
							{
								start: time_window.init_hour,
								end: time_window.end_hour,
							}
						)
					"
				/>
			</vs-sidebar>
			<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
				<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
					<vx-card :cardBorder="true" :noShadow="true" :title="$t('RepeatFormat')">
						<template slot="actions">
							<vs-button
								class="ml-2 mr-2 font-bold"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-calendar"
								@click.prevent="isSidebarCalendar = true"
								>{{ $t("TimeWindow.Schedule") }}
							</vs-button>
						</template>
						<form data-vv-scope="create-visit-point">
							<div class="vx-row">
								<div class="vx-col w-full">
									<repeat-cron @updateCronExpressionEmit="getCronExpression" />
								</div>
							</div>
						</form>
					</vx-card>
					<vx-card class="mt-base" :cardBorder="true" :noShadow="true" :title="$t('TimeWindow.TimeWindow')">
						<repeat-time-windows :time-window.sync="time_window" />
					</vx-card>
				</vue-perfect-scrollbar>
			</div>
			<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
				<transition name="fade">
					<generate-repeat-items
						:activeTabRepeat="activeTabRepeat"
						@updatePickupPoints="getPickupPoints"
						@updateDeliveryPoints="getDeliveryPoints"
						@updateVehicles="getVehicles"
					/>
				</transition>
			</div>
		</div>
		<div class="vx-row mt-4">
			<div class="vx-col w-full">
				<div class="flex flex-wrap items-center justify-end">
					<vs-button class="ml-auto" color="danger" @click.prevent="closePopupGenerateRepeat()">{{
						$t("Cancel")
					}}</vs-button>
					<vs-button class="ml-4" :disabled="isDisabled" @click.prevent="generateRepeat()">{{
						$t("Generate")
					}}</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {generateRepeatMixin} from "@/components/optimization/generate-repeat/GenerateRepeatMixin.js";

export default {
	mixins: [generateRepeatMixin],
};
</script>
<style lang="scss" scoped>
.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 620px;
	max-height: 589px;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
	padding: 10px !important;
}
.add-sidebar--repeat {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 50vw;
		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
